

// Rapport gain / coût sur un risque

      const rapportGC = (proba, impact, maitrise) => {
            return ((proba * impact) - (maitrise * maitrise))/6
      }

      export default rapportGC